/**
 * ResetPasswordHero — left-panel content for AUTH-04 Password Reset.
 *
 * "Security Policy" label + password requirements listed as hero copy so the
 * user can see the rules without the form obscuring them. Figma frame 79:22.
 */
export function ResetPasswordHero() {
  return (
    <div className="flex flex-col gap-4">
      <p className="text-base text-[var(--text-secondary)]">Security Policy</p>
      <p className="text-base leading-relaxed text-[var(--text-secondary)]">
        New password must be 8+
        <br />
        chars with uppercase,
        <br />
        lowercase, and a number.
      </p>
    </div>
  );
}
